import React, { useState, useRef } from 'react';
import { InputNesting } from './common/Inputs/Input';
import { useTranslate } from '../lib';
import '../styles/swicthcss.css';

export function AddEvaluationCriteriaModal({ isOpen, onClose, onEvaluationCriteriaAdded }) {
    const { t } = useTranslate();
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    
    // Estados para evaluación personalizada
    const [evaluationName, setEvaluationName] = useState('');
    const [customEvaluation, setCustomEvaluation] = useState({
        industry: 'custom',
        evaluation_structure: []
    });
    const [currentSection, setCurrentSection] = useState({ section: '', criteria: [''] });
    const handleClose = () => {
        setEvaluationName('');
        setCustomEvaluation({
            industry: 'custom',
            evaluation_structure: []
        });
        setCurrentSection({ section: '', criteria: [''] });
        setError('');
        onClose();
    };

    const addCriterionToSection = () => {
        setCurrentSection({
            ...currentSection,
            criteria: [...currentSection.criteria, '']
        });
    };

    const updateCriterion = (index, value) => {
        const updatedCriteria = [...currentSection.criteria];
        updatedCriteria[index] = value;
        setCurrentSection({ ...currentSection, criteria: updatedCriteria });
    };

    const removeCriterion = (index) => {
        const updatedCriteria = currentSection.criteria.filter((_, i) => i !== index);
        setCurrentSection({ ...currentSection, criteria: updatedCriteria });
    };

    const addSectionToEvaluation = () => {
        if (currentSection.section && currentSection.criteria.filter(c => c.trim()).length > 0) {
            const validCriteria = currentSection.criteria.filter(c => c.trim());
            setCustomEvaluation({
                ...customEvaluation,
                evaluation_structure: [
                    ...customEvaluation.evaluation_structure,
                    { section: currentSection.section, criteria: validCriteria }
                ]
            });
            setCurrentSection({ section: '', criteria: [''] });
        }
    };

    const removeSection = (index) => {
        const updatedStructure = customEvaluation.evaluation_structure.filter((_, i) => i !== index);
        setCustomEvaluation({ ...customEvaluation, evaluation_structure: updatedStructure });
    };

    const saveCustomCriteria = () => {
        if (customEvaluation.evaluation_structure.length > 0) {
            setIsLoading(true);
            if (!evaluationName.trim()) {
                setError(t('menu.genai.evaluationNameRequired') || 'Evaluation name is required');
                setIsLoading(false);
                return;
            }

            setError('');
            
            try {
                // Llamar al callback con la evaluación personalizada y su nombre
                onEvaluationCriteriaAdded({ 
                    name: evaluationName.trim(), 
                    ...customEvaluation 
                });
                
                // Resetear el estado
                setEvaluationName('');
                setCustomEvaluation({
                    industry: 'custom',
                    evaluation_structure: []
                });
                setCurrentSection({ section: '', criteria: [''] });
                
                onClose();
            } catch (error) {
                setError(t('errors.savingCustomCriteria') || 'Error saving custom criteria');
                console.error('Error saving custom criteria:', error);
            } finally {
                setIsLoading(false);
            }
        } else {
            setError(t('menu.genai.addAtLeastOneSection') || 'Please add at least one section with criteria');
        }
    };

    const getAllExistingSections = () => {
        // Secciones de referencia hardcodeadas
        return [
            'Active Listening & Emotional Connection',
            'Empathy & Problem-Solving Mindset',
            'Clear Communication & Transparency',
            'Proactive Assistance & Follow-Up',
            'Product Knowledge & Expertise',
            'Personalization & Customer Focus',
            'Conflict Resolution & De-escalation',
            'Efficiency & Time Management',
            'Professional Tone & Courtesy',
            'Compliance & Policy Adherence'
        ];
    };



    if (!isOpen) return null;

    return (
        <div className="modal-overlay" style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000
        }}>
            <div className="modal-content" style={{
                backgroundColor: 'white',
                borderRadius: '8px',
                padding: '24px',
                width: '90%',
                maxWidth: '900px',
                maxHeight: '85vh',
                overflowY: 'auto',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
            }}>
                <h2 style={{ 
                    margin: '0 0 20px 0', 
                    fontSize: '20px', 
                    fontWeight: 'bold',
                    color: '#0B5FA3'
                }}>
                    {t('menu.genai.createCustomEvaluation') || 'Create Custom Evaluation Criteria'}
                </h2>
                
                <div id="container-modal" style={{ width: '100%' }}>

                            {/* Campo para el nombre de la evaluación */}
                            <div className="input mb-4">
                                <label style={{ fontWeight: 700, color: '#2E2E2E', marginBottom: 5 }}>
                                    {t('menu.genai.evaluationName') || 'Evaluation Name'}:
                                </label>
                                <input
                                    type="text"
                                    value={evaluationName}
                                    onChange={(e) => setEvaluationName(e.target.value)}
                                    placeholder={t('menu.genai.enterEvaluationName') || 'Enter evaluation name'}
                                    style={{ width: '100%', padding: 10, borderRadius: 5, border: '1px solid #ccc' }}
                                />
                            </div>

                            {/* Guía de secciones existentes */}
                            <div className="mb-4 p-3" style={{ backgroundColor: '#F0F8FF', borderRadius: 8, border: '1px solid #1C6FB0' }}>
                                <h3 style={{ color: '#0B5FA3', fontSize: 16, marginBottom: 10 }}>
                                    {t('menu.genai.existingSections') || 'Reference Sections'}:
                                </h3>
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                                    {getAllExistingSections().map((section, idx) => (
                                        <span
                                            key={idx}
                                            style={{
                                                backgroundColor: '#E3F2FD',
                                                padding: '5px 12px',
                                                borderRadius: 15,
                                                fontSize: 13,
                                                color: '#0B5FA3',
                                                border: '1px solid #90CAF9'
                                            }}
                                        >
                                            {section}
                                        </span>
                                    ))}
                                </div>
                            </div>

                            {/* Formulario para agregar nueva sección */}
                            <div className="mb-4 p-3" style={{ backgroundColor: '#FAFAFA', borderRadius: 8 }}>
                                <h3 style={{ color: '#0B5FA3', fontSize: 16, marginBottom: 15 }}>
                                    {t('menu.genai.addNewSection') || 'Add New Section'}
                                </h3>

                                <div className="input mb-3">
                                    <label style={{ fontWeight: 700, color: '#2E2E2E', marginBottom: 5 }}>
                                        {t('menu.genai.sectionName') || 'Section Name'}:
                                    </label>
                                    <input
                                        type="text"
                                        value={currentSection.section}
                                        onChange={(e) => setCurrentSection({ ...currentSection, section: e.target.value })}
                                        placeholder={t('menu.genai.enterSectionName') || 'Enter section name'}
                                        style={{ width: '100%', padding: 10, borderRadius: 5, border: '1px solid #ccc' }}
                                    />
                                </div>

                                <div className="mb-3">
                                    <label style={{ fontWeight: 700, color: '#2E2E2E', marginBottom: 5 }}>
                                        {t('menu.genai.criteria') || 'Criteria'}:
                                    </label>
                                    {currentSection.criteria.map((criterion, index) => (
                                        <div key={index} className="flex items-center mb-2">
                                            <input
                                                type="text"
                                                value={criterion}
                                                onChange={(e) => updateCriterion(index, e.target.value)}
                                                placeholder={`${t('menu.genai.criterion') || 'Criterion'} ${index + 1}`}
                                                style={{ flex: 1, padding: 10, borderRadius: 5, border: '1px solid #ccc' }}
                                            />
                                            <button
                                                type="button"
                                                onClick={() => removeCriterion(index)}
                                                className="ml-2 btn-delete"
                                                style={{ marginTop: 0 }}
                                            >
                                                <img src="/icons/trash-1.png" alt="" style={{ width: 20 }} />
                                            </button>
                                        </div>
                                    ))}
                                </div>

                                <div className="d-flex" style={{ gap: 10 }}>
                                    <button
                                        type="button"
                                        className="btn-add"
                                        onClick={addCriterionToSection}
                                        style={{ flex: 1 }}
                                    >
                                        <img src="/icons/add-icon-nt.png" style={{ width: 20 }} alt="" />
                                        <span className="ml-2">{t('menu.genai.addCriterion') || 'Add Criterion'}</span>
                                    </button>

                                    <button
                                        type="button"
                                        className="btn-primary"
                                        onClick={addSectionToEvaluation}
                                        style={{
                                            flex: 1,
                                            backgroundColor: '#0087FF',
                                            color: 'white',
                                            padding: '10px 20px',
                                            borderRadius: 5,
                                            border: 'none',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                    >
                                        <img src="/icons/check-icon.png" style={{ width: 20, filter: 'brightness(0) invert(1)' }} alt="" />
                                        <span className="ml-2">{t('menu.genai.addSection') || 'Add Section'}</span>
                                    </button>
                                </div>
                            </div>

                            {/* Secciones agregadas */}
                            {customEvaluation.evaluation_structure.length > 0 && (
                                <div className="mb-4">
                                    <h3 style={{ color: '#0B5FA3', fontSize: 16, marginBottom: 15 }}>
                                        {t('menu.genai.addedSections') || 'Added Sections'} ({customEvaluation.evaluation_structure.length})
                                    </h3>
                                    {customEvaluation.evaluation_structure.map((section, sectionIdx) => (
                                        <div
                                            key={sectionIdx}
                                            className="mb-3 p-3"
                                            style={{
                                                backgroundColor: '#F9F9F9',
                                                borderRadius: 8,
                                                border: '1px solid #E0E0E0'
                                            }}
                                        >
                                            <div className="d-flex justify-space-between align-items-center mb-2">
                                                <h4 style={{ color: '#2E2E2E', fontSize: 15, fontWeight: 700, margin: 0 }}>
                                                    {section.section}
                                                </h4>
                                                <button
                                                    type="button"
                                                    onClick={() => removeSection(sectionIdx)}
                                                    className="btn-delete"
                                                >
                                                    <img src="/icons/trash-1.png" alt="" style={{ width: 20 }} />
                                                </button>
                                            </div>
                                            <ul style={{ marginLeft: 20, marginTop: 10 }}>
                                                {section.criteria.map((criterion, criterionIdx) => (
                                                    <li key={criterionIdx} style={{ color: '#555', marginBottom: 5 }}>
                                                        {criterion}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    ))}
                                </div>
                            )}

                            {/* Error message */}
                            {error && (
                                <div style={{
                                    color: '#dc3545',
                                    fontSize: '14px',
                                    marginBottom: '16px',
                                    padding: '8px 12px',
                                    backgroundColor: '#f8d7da',
                                    border: '1px solid #f5c6cb',
                                    borderRadius: '4px'
                                }}>
                                    {error}
                                </div>
                            )}

                            {/* Botones del modal */}
                            <div style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                gap: '12px',
                                marginTop: '20px'
                            }}>
                                <button
                                    type="button"
                                    onClick={handleClose}
                                    disabled={isLoading}
                                    style={{
                                        padding: '8px 16px',
                                        border: '1px solid #ccc',
                                        borderRadius: '4px',
                                        backgroundColor: 'white',
                                        color: '#333',
                                        cursor: isLoading ? 'not-allowed' : 'pointer',
                                        fontSize: '14px'
                                    }}
                                >
                                    {t('common.cancel')}
                                </button>
                                <button
                                    type="button"
                                    onClick={saveCustomCriteria}
                                    disabled={isLoading || customEvaluation.evaluation_structure.length === 0}
                                    style={{
                                        padding: '8px 16px',
                                        border: 'none',
                                        borderRadius: '4px',
                                        backgroundColor: '#0087FF',
                                        color: 'white',
                                        cursor: (isLoading || customEvaluation.evaluation_structure.length === 0) ? 'not-allowed' : 'pointer',
                                        fontSize: '14px',
                                        opacity: (isLoading || customEvaluation.evaluation_structure.length === 0) ? 0.6 : 1
                                    }}
                                >
                                    {isLoading ? t('common.saving') || 'Saving...' : t('common.save')}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
    );
}